import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import GridCard from '../components/GridCard'
import GeneralDocs from '../components/GeneralDocs'
import GeneralInfo from '../components/GeneralInfo'
import SelectionBar from '../components/selection/SelectionBar'
import { config } from '../settings/configs'
import { useGetDesignazioniStatsQuery } from '../hooks/api-slice'

const DashboardDesignatore = () => {
  const selectedCampionato = useSelector(
    state => state.selection.selectedCampionato,
  )

  document.title = `${config?.name} - Home`

  const { data: designazioniStats } = useGetDesignazioniStatsQuery(
    { campionato: selectedCampionato },
    { skip: !selectedCampionato },
  )

  return (
    <Grid
      container
      paddingX={2}
      marginY={2}
      rowSpacing={3}
      columnSpacing={2}
      alignItems='stretch'
      sx={{ width: '100%' }}
    >
      <GeneralInfo />
      <Grid container alignItems='center' sx={{ width: '100%' }}>
        <SelectionBar yCampionato />
      </Grid>
      <p style={{ margin: 20, width: '100%' }}>
        Benvenuto nel profilo di designazione di {config?.name}.
        <br />
        {config?.features?.designazioni && (
          <>
            Dalla pagina <b>Designazioni</b> puoi scegliere gli arbitri per le
            prossime partite.
            <br />
          </>
        )}
        Buon lavoro!
      </p>
      {config?.features?.designazioni && (
        <GridCard
          title='Designazioni'
          subtitle1={`${designazioniStats?.missing10days || 0} ${
            designazioniStats?.missing10days === 1
              ? 'mancante (10 giorni)'
              : 'mancanti (10 giorni)'
          }`}
          subtitle2={`${designazioniStats?.waiting || 0} ${
            designazioniStats?.waiting === 1 ? 'in sospeso' : 'in sospeso'
          }`}
          linkTo='/designazioni'
          isError={
            designazioniStats?.waiting + designazioniStats?.missing10days > 0
          }
        />
      )}
      <GeneralDocs />
    </Grid>
  )
}

export default DashboardDesignatore
